import Rule from '@/domain/rule/entity/rule.entity';
import ContractRule from '@/domain/contract/entity/contract-rule.entity';

export default class ProductTemplateRule {
  id: string;

  productId: number;

  description: string;

  observation: string;

  rules: ContractRule[] = [];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.productId = obj.productId || 0;
    this.description = obj.description || '';
    this.observation = obj.observation || '';
    if (obj.rules) {
      this.rules = ContractRule.ofList(obj.rules);
    }
    this.verifyRuleLength();
  }

  public static of(obj: any = {}): ProductTemplateRule {
    return new ProductTemplateRule(obj || {});
  }

  public static ofList(obj: any[]): ProductTemplateRule[] {
    return obj.map(this.of);
  }

  verifyRuleLength() {
    if (this.rules.length === 0) {
      this.rules.push(ContractRule.of({}));
    }
  }

  updateRules(productRule: Rule, index: number) {
    this.rules.splice(index, 1, ContractRule.of(productRule));
  }

  clearRule(index: number) {
    this.rules.splice(index, 1, ContractRule.of({}));
  }

  addNewRule() {
    this.rules.push(ContractRule.of({}));
  }
}
